import React from 'react';
import { cn } from '@/lib/utils';

interface AppVersionProps {
  className?: string;
}

/**
 * The release version this bundle was built as, baked in at build time by
 * vite.config.ts (`define: __APP_VERSION__`) from scripts/lib/version.mjs.
 *
 * Renders nothing when the version is empty — that happens only when no git tag
 * was reachable at build time AND package.json carried no version, and a bare
 * "v" is worse than an absent line.
 *
 * Not translated on purpose: a semver string reads the same in English and
 * Sinhala, and adding a key here would mean keeping it in parity across both
 * translation files for no gain.
 */
export const AppVersion: React.FC<AppVersionProps> = ({ className }) => {
  if (!__APP_VERSION__) return null;

  return (
    <span
      className={cn('font-mono text-xs text-muted-foreground', className)}
      data-testid="app-version"
    >
      {__APP_VERSION__}
    </span>
  );
};
